import styled from "styled-components";
import {Button} from "govuk-react";
import {Container} from "../../theme/elements";

export const CookieMessageContainer= styled.div`
    background-color: #f3f2f1;
    padding: 20px 20px 0;
    box-sizing: border-box;

    h2 {
       margin-top:0;
       margin-bottom: 20px;
       font-size: 24px;
    }

   @media (min-width: 768px) {
      padding-left: 20px;
      padding-right: 20px;
   }
`

export  const InnerWrapper = styled(Container)`
  display: flex;
  flex-direction: column;
`


export const Actions= styled.div`
 display: flex;
 flex-direction: column;
 justify-content: space-between;
  
  @media (min-width: 992px) {
      flex-direction: row;
  }
`

export const Bttns = styled(Button)`
  width: 100%%;
  
  @media (min-width: 992px) {
     width: 47%;
  }
`;
